import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { fetchEducationEvents } from '../actions'
import * as selectors from '../selectors'
import useOnMount from '../hooks/useOnMount'

EducationProfileEvents.propTypes = {
  children: PropTypes.func.isRequired,
  merchantEducationEvents: PropTypes.arrayOf(PropTypes.object),
  fetchEducationEvents: PropTypes.func.isRequired
}

/** use render-props pattern to pass events attached to current merchant to child components  */
function EducationProfileEvents({ children, merchantEducationEvents, fetchEducationEvents }) {
  useOnMount(fetchEducationEvents)

  return merchantEducationEvents ? children(merchantEducationEvents) : null
}

export default connect(
  state => ({
    merchantEducationEvents: selectors.merchantEducationEvents(state)
  }),
  { fetchEducationEvents }
)(EducationProfileEvents)
